import { render, staticRenderFns } from "./FormIndustry.vue?vue&type=template&id=18fc81e3"
import script from "./FormIndustry.vue?vue&type=script&lang=js"
export * from "./FormIndustry.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* custom blocks */
import block0 from "./FormIndustry.vue?vue&type=custom&index=0&blockType=docs"
if (typeof block0 === 'function') block0(component)

/* hot reload */
if (module.hot) {
  var api = require("/home/vsts/work/1/s/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('18fc81e3')) {
      api.createRecord('18fc81e3', component.options)
    } else {
      api.reload('18fc81e3', component.options)
    }
    module.hot.accept("./FormIndustry.vue?vue&type=template&id=18fc81e3", function () {
      api.rerender('18fc81e3', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/modules/clients/components/FormIndustry.vue"
export default component.exports